<template>
  <modal-campaign-targeting-rule @save="save" @close="close">
    <div v-for="(row, key1) in value" :key="key1">
      <div class="d-flex align-items-center my-2">
        <span class="mr-2 flex-shrink-0">Page url(s)</span>
        <targeting-string-compare-operator-selector
          class="mr-2"
          :value="row.filter"
          @change="(e) => setRowValue(key1, 'filter', e.target.value)"
        ></targeting-string-compare-operator-selector>
        <targeting-url-input
          class="mr-4"
          :show-domain="showDomain(row.filter)"
          :value="row.value"
          @input="(e) => setRowValue(key1, 'value', e.target.value)"
        ></targeting-url-input>
        <span class="mr-2 flex-shrink-0">Blocking time in seconds:</span>
        <input
          class="form-control form-control-sm mr-4"
          :value="parseInt(row.time) / 1000"
          @input="(e) => setRowValue(key1, 'time', e.target.value)"
        />
        <button class="btn btn-icon btn-soft-danger btn-sm flex-shrink-0" type="button" @click="removeRow(key1)" v-if="value.length > 1">
          <i class="tio-remove-from-trash"></i>
        </button>
      </div>
      <div class="my-3 text-center">
        <div class="mb-2">OR</div>
      </div>
    </div>
    <div class="mt-3 text-center">
      <button class="btn btn-icon btn-soft-primary btn-sm" type="button" @click="addOrRow"><i class="tio-add"></i></button>
    </div>
  </modal-campaign-targeting-rule>
</template>

<script>
import ModalCampaignTargetingRule from "@/components/modals/ModalCampaignTargetingRule"
import targetingRuleNames from "@/components/campaign-targeting-rules/targetingRuleNames"
import targetingRuleModalMixin from "@/components/campaign-targeting-rules/modals/targeting-rule-modal-mixin"
import TargetingStringCompareOperatorSelector from "@/components/campaign-targeting-rules/TargetingStringCompareOperatorSelector"
import TargetingUrlInput from "@/components/campaign-targeting-rules/TargetingUrlInput"

const mixin = targetingRuleModalMixin("who", targetingRuleNames.whoRules.excludeByVisit)

export default {
  name: "ExcludeByVisitModal",
  components: { ModalCampaignTargetingRule, TargetingStringCompareOperatorSelector, TargetingUrlInput },
  mixins: [mixin],
  methods: {
    showDomain(filter) {
      return filter === "equals" || filter === "notEquals" || filter === "startsWith" || filter === "notStartsWith"
    },
    addOrRow() {
      this.value.push({ filter: "equals", value: "", time: "0" })
      this.value = [...this.value]
    },
    setRowValue(key1, key2, value) {
      if (key2 === "time") {
        value = value * 1000
      }
      this.value[key1][key2] = value
      this.value = [...this.value]
    },
    removeRow(key) {
      let tmp = this.value
      tmp.splice(key, 1)
      this.value = tmp
      this.value = [...this.value]
    }
  }
}
</script>
